import { Component, EventEmitter, Input, Output, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { GraphDataEthnicity } from '../../backend-response-models/calc-enums.helper';
import { Dataset } from '../../shared/shared-enums/enum-helper';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { TranslatePipe } from '../../languages/translate.pipe';
import { DropdownModule } from 'primeng/dropdown';
import { COMMON_IMPORTS } from '../../common-imports';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-comparative-ser-data',
  standalone: true,
  imports: [DropdownModule, TableModule, ...COMMON_IMPORTS],
  templateUrl: './comparative-ser-data.component.html',
  styleUrl: './comparative-ser-data.component.css',
})
export class ComparativeSerDataComponent implements OnInit, OnChanges {
  @Input()
  ethnicity?: GraphDataEthnicity;

  @Output()
  ethnicityChanged = new EventEmitter<GraphDataEthnicity>();

  public ethnicityDict: Record<GraphDataEthnicity, string> = {
    [GraphDataEthnicity.WESTERN]: 'WESTERN_DATA_CHOICE',
    [GraphDataEthnicity.EAST_ASIAN]: 'EAST_ASIAN_DATA_CHOICE',
  };
  public dataSets: Dataset[] = [];
  public selectedDataset?: Dataset;

  private serDataWestern: SerRow[] = [
    { age: '6', expectedSer: '-0.50' },
    { age: '7', expectedSer: '-0.45' },
    { age: '8', expectedSer: '-0.41' },
    { age: '9', expectedSer: '-0.36' },
    { age: '10', expectedSer: '-0.32' },
    { age: '11', expectedSer: '-0.28' },
    { age: '12', expectedSer: '-0.23' },
    { age: '13', expectedSer: '-0.19' },
    { age: '14', expectedSer: '-0.14' },
    { age: '15', expectedSer: '-0.10' },
    { age: '16', expectedSer: '-0.06' },
  ];

  private serDataEastern: SerRow[] = [
    { age: '6', expectedSer: '-1' },
    { age: '7', expectedSer: '-0.92' },
    { age: '8', expectedSer: '-0.84' },
    { age: '9', expectedSer: '-0.76' },
    { age: '10', expectedSer: '-0.68' },
    { age: '11', expectedSer: '-0.60' },
    { age: '12', expectedSer: '-0.52' },
    { age: '13', expectedSer: '-0.44' },
    { age: '14', expectedSer: '-0.36' },
    { age: '15', expectedSer: '-0.29' },
    { age: '16', expectedSer: '-0.21' },
  ];

  public selectedSerData: SerRow[] = [];
  public studyReference = '';

  constructor(private translatePipe: TranslatePipe) {}

  ngOnInit(): void {
    if (!this.ethnicity) {
      this.ethnicity = GraphDataEthnicity.WESTERN;
    }
    this.refreshAll();
  }

  private addDataSets() {
    this.dataSets = [
      {
        label: this.translatePipe.transform('WESTERN_DATA_CHOICE'),
        value: GraphDataEthnicity.WESTERN,
      },
      {
        label: this.translatePipe.transform('EAST_ASIAN_DATA_CHOICE'),
        value: GraphDataEthnicity.EAST_ASIAN,
      },
    ];
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.refreshAll();
  }

  private refreshAll() {
    this.addDataSets();
    this.selectedDataset = this.dataSets.find(d => d.value === (this.ethnicity ?? GraphDataEthnicity.WESTERN));
    const ethnicitySelected = this.selectedDataset?.value;
    this.selectedSerData = ethnicitySelected === GraphDataEthnicity.WESTERN ? this.serDataWestern : this.serDataEastern;
    const studyReferenceKey = 'COMPARATIVE_DATA_STUDY_REFRENCE_1';
    this.studyReference = this.translatePipe.transform(studyReferenceKey);
  }

  onDatasetChanged(event: DropdownChangeEvent) {
    this.ethnicity = event.value.value;
    this.selectedDataset = event.value;
    this.refreshAll();
    this.ethnicityChanged.emit(this.ethnicity);
  }
}

export interface SerRow {
  age: string;
  expectedSer: string;
}
